/* eslint-disable
    max-statements-per-line,
*/
export default capitalize

/** @ngInject */
function capitalize() {
    return function (input) {
        if (input) {
            return input.charAt(0).toUpperCase() + input.substr(1).toLowerCase()
        }
        return ''
    }
}



// WEBPACK FOOTER //
// ./src/services/filters/capitalize.js